import React, { useState } from 'react';
import { Card, Typography, Input, List, Avatar, Tag, Space } from 'antd';
import { SearchOutlined, UserOutlined } from '@ant-design/icons';
import api from '../api/api';
import dayjs from 'dayjs';
import usePageMeta from '../hooks/usePageMeta';

function UserSearch() {
  const { Title, Text ,Link  } = Typography;
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  usePageMeta('搜尋用戶 | 光暈戰記排行榜', 'https://twilightwarscloudflarereact.pages.dev/search');

  const handleSearch = async (value) => {
    const keyword = (value || '').trim();
    if (!keyword) {
      setResults([]);
      return;
    }
    setLoading(true);
    try {
      const res = await api.searchUser(keyword);
      const arr = Array.isArray(res?.result) ? res.result : [];
      const flat = arr.flatMap(x => Array.isArray(x) ? x : []);
      setResults(flat);
    } catch (e) {
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const renderTitle = (item) => {
    const role = item?.role;
    return (
      <Space size={8} wrap>
        <span>{item?.nickname || '未知暱稱'}</span>
        <Text type="secondary"><Link href={`https://gamelet.online/user/${item?.username}`}>({item?.username})</Link></Text>
        {role ? <Tag color="gold">{role}</Tag> : null}
      </Space>
    );
  };

  const renderDesc = (item) => {
    const lastAccess = item?.lastAccess ? dayjs.unix(item.lastAccess).format('YYYY-MM-DD HH:mm:ss') : '未知時間';
    const lastGame = item?.meta?.lastGame;
    return (
      <div>
        <div>最後存取：{lastAccess}</div>
        {lastGame ? (
          <div>
            最近遊戲：{lastGame.name} ({lastGame.code})，{dayjs.unix(lastGame.time).format('YYYY-MM-DD HH:mm:ss')}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div style={{ padding: '1.25rem' }}>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
          <Title level={2} style={{ margin: 0 }}>
            <SearchOutlined style={{ marginRight: '0.5rem' }} />
            搜尋用戶
          </Title>
        </div>

        <div style={{ marginBottom: '1.25rem' }}>
          <Input.Search
            placeholder="輸入暱稱或帳號..."
            allowClear
            enterButton={<SearchOutlined />}
            size="large"
            onSearch={handleSearch}
            loading={loading}
            style={{ maxWidth: '28rem' }}
          />
        </div>

        <List
          itemLayout="horizontal"
          dataSource={results}
          locale={{ emptyText: '請輸入關鍵字進行搜尋' }}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={item?.iconUrl} icon={<UserOutlined />} />}
                title={renderTitle(item)}
                description={renderDesc(item)}
              />
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
}

export default UserSearch;


